import LabelLang from "component/LabelLang/label-lang";
import { FormattedMessage } from "react-intl";

function MainDepartment({ getDepartment }) {
  const { name, departmentTranslations, phoneNumber, email, address } =
    getDepartment?.data?.data;

  return (
    <>
      {getDepartment?.data?.data === null ||
      getDepartment?.data?.data === undefined ? (
        ""
      ) : (
        <div className="box-info">
          <div className="box-info-header">
            <p className="mb-1">
              <FormattedMessage id="responsible" />
            </p>
            <b style={{ color: "#FFF" }}>
              {" "}
              {name !== null && name.length > 0 ? (
                <LabelLang
                  id="name"
                  defaultValue={name}
                  translations={departmentTranslations}
                />
              ) : (
                <FormattedMessage id="data-not-found" />
              )}
            </b>
          </div>
          <ul>
            {[
              { key: phoneNumber, image: "info1.svg", dir: "ltr" },
              { key: email, image: "info2.svg", dir: "rtl" },
            ].map(({ key, image, dir }, i) => (
              <li key={i}>
                <img
                  loading="lazy"
                  src={process.env.PUBLIC_URL + `/image/${image}`}
                  alt="logo-info"
                />
                <span dir={dir}>
                  {key !== null && key.length > 0 ? (
                    <>{key}</>
                  ) : (
                    <FormattedMessage id="data-not-found" />
                  )}
                </span>
              </li>
            ))}
            <li key={2}>
              <img
                loading="lazy"
                src={process.env.PUBLIC_URL + `/image/info3.svg`}
                alt="logo-info"
              />
              <span dir={"rtl"}>
                {address !== null && address.length > 0 ? (
                  <LabelLang
                    id="address"
                    defaultValue={address}
                    translations={departmentTranslations}
                  />
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
              </span>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default MainDepartment;
